// extracted by mini-css-extract-plugin
export default {"contents":"styles_contents__uuQxT","social":"styles_social__bH9wi","icons":"styles_icons__qRaLB","box":"styles_box__YyaBR"};